import { Pipe, PipeTransform } from '@angular/core'
import { RecordingClockAnchor } from './calls.service'

/**
 * The time of day at which a moment of the recording happened. Within a segment the recording runs in real time, so
 * it is the last anchor at or before the moment plus the difference; pauses and rejoins fall between segments, and
 * each segment's anchor already accounts for them.
 */
export function recordingPositionToDate(anchors: RecordingClockAnchor[], recordingPosition: number): Date | null {
  const anchor = anchors.findLast((candidate) => candidate.recordingPosition <= recordingPosition) ?? anchors.at(0) ?? null
  if (anchor === null) {
    return null
  }
  return new Date(new Date(anchor.date).getTime() + (recordingPosition - anchor.recordingPosition) * 1000)
}

@Pipe({
  name: 'recordingClock',
  standalone: true,
})
export class RecordingClockPipe implements PipeTransform {
  transform(recordingPosition: number, anchors: RecordingClockAnchor[] | null): Date | null {
    return anchors === null ? null : recordingPositionToDate(anchors, recordingPosition)
  }
}
